export const environment = {
    LEGACY_URL: 'https://webapps-staging.seplag.ce.gov.br',
    API_URL: 'https://hmlapi.sgprev.cearaprev.ce.gov.br',
    API_URL_SGPREV: 'https://seplagapihml.cearaprev.ce.gov.br/cearaprev',
    env: 'HML',
};
